import { render, staticRenderFns } from "./_dailyWinloseByPlatform.vue?vue&type=template&id=097b6033&lang=pug&"
import script from "./_dailyWinloseByPlatform.vue?vue&type=script&lang=js&"
export * from "./_dailyWinloseByPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports